// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3XfwJ","icon":"style_icon__2dKzU","title":"style_title__342-q","logo":"style_logo__1DMEi","logoContainer":"style_logoContainer__Wceh5"};